import React from 'react';
import { BsFillPersonFill } from 'react-icons/bs';

import { Container } from './styles';

const Avatar = (): JSX.Element => {
  return (
    <Container>
      <BsFillPersonFill />
    </Container>
  );
};

export default Avatar;
